/*  eslint-disable camelcase */
import { Cart } from '../../util/typings';

export interface IFReduxCart {
  cartActive: boolean;
  minicartOpen: boolean;
  current: Cart;
  updating: boolean;
}

const cart: Cart = {
  token: '',
  note: '',
  attributes: {},
  total_price: 0, 
  total_weight: 0,
  total_discount: 0,
  original_total_price: 0,
  item_count: 0,
  requires_shipping: true,
  currency: '',
  items: [],
}

const cartInitialState: IFReduxCart = {
  cartActive: false,
  minicartOpen: false,
  current: cart,
  updating: false,
}


export default cartInitialState